// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body {\n  background-color: white;\n  font-family: lato, sans-serif;\n  font-weight: 400;\n}\n", "",{"version":3,"sources":["webpack://src/Screens/Setgoal/SetGoalStyle.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,gBAAgB;AAClB","sourcesContent":["body {\n  background-color: white;\n  font-family: lato, sans-serif;\n  font-weight: 400;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
